export enum CustomMessageShowType {
  ONE_TIME = 'OneTime',
  DAILY = 'Daily',
  ALWAYS = 'Always'
}
